import { useSelector, useDispatch } from 'react-redux';
import {
	getKeys,
	getSorting,
	getFilter,
	hasNoResults,
	appliedFilterCount,
	isAdvancedSearchOpen,
	getCountryActionPills,
	getblkSNAckActionPills
} from '../state/gridSelectors';
import { sortGrid, filterGrid } from '../state/gridActions';
import { _initialGridState } from '../state/gridReducer';
import { useGridContext } from './gridContext';

const DEFAULT_GRID_FILTER = { ..._initialGridState.filter };
const DEFAULT_COUNTRY_PILLS = { ..._initialGridState.countrySummaryActions };
const DEFAULT_BLK_PILLS = { ..._initialGridState.blkAcknowledgeActions };

const DataConsumer = ({ children }) => {
	const gridName = useGridContext();
	const dispatch = useDispatch();
	const gridMeta = useSelector(state => ({
		keys: getKeys(state, gridName),
		sorting: getSorting(state, gridName) || { sortBy: '', sortOrder: '' },
		currentFilter: getFilter(state, gridName) ?? DEFAULT_GRID_FILTER,
		isAdvancedSearchOpen: Boolean(isAdvancedSearchOpen(state, gridName)),
		appliedFilterCount: appliedFilterCount(state, gridName),
		hasNoResults: hasNoResults(state, gridName),
		countryActionPills: getCountryActionPills(state, gridName) ?? DEFAULT_COUNTRY_PILLS,
		blkSNAckActionPills: getblkSNAckActionPills(state, gridName) ?? DEFAULT_BLK_PILLS
	}));
	const actions = {
		sort: (sortBy) => dispatch(sortGrid(gridName, sortBy)),
		filter: (search) => dispatch(filterGrid(gridName, search))
	};
	return children(gridMeta, actions, gridName);
};

export default DataConsumer;
